/**
 * Created by juyang on 2017/9/14.
 */
'use strict';
define(['../../base/Class','../../g2'],function (Class,g2) {
    function PolygonElement(coords, opt) {
        Class.setOptions(this, opt);

        this.coords = coords;
        this.options.geometry = this.getGeometry();
        g2.sfs.Element.call(this, this.options)

    }
    PolygonElement.prototype = {
        options: {},
        constructor: PolygonElement,
        /**
         * 获取g2.
         * @returns {*}
         */
        getGeometry: function () {
            var objToString = Object.prototype.toString
            if (this.coords instanceof g2.sfs.Polygon)
                return this.coords
            else if (objToString.call(this.coords) === '[object Array]') {
                return this._areaPolygon(this.coords);
            }
            else if (objToString.call(this.coords) === '[object String]' && this.coords.indexOf('polygon') > -1) {

                return g2.sfs.GeometryFactory.createGeometryFromWkt(this.coords);

            }
            else if ((typeof this.coords === 'function' || (!!this.coords && typeof this.coords == 'object')) && this.coords.type == 'Polygon') {
                return g2.sfs.GeometryFactory.createGeometryFromGeoJson(this.coords);
            }
            else {
                console.error(('数据类型错误，只支持数组坐标、g2.sfs.Polygon、geojson、wkt'))
            }
        },
        _ring: function (ps) {
            var areaRing = new g2.sfs.Ring();
            ps.map(function (p) {
                var point = p instanceof g2.sfs.Point ? p : new g2.sfs.Point({x: p[0], y: p[1]});
                areaRing.addPoint(point);
            })
            return areaRing;
        },
        _areaPolygon: function (pss) {
            var areaPolygon = new g2.sfs.Polygon();
            if (pss && pss[0] && pss[0][0] && pss[0][0].length == 2) {
                pss.map($.proxy(function (item) {
                    areaPolygon.addGeometry(this._ring(item));
                }, this))
            }
            else {
                areaPolygon.addGeometry(this._ring(pss));
            }
            return areaPolygon;
        },
        envelope: function () {
            return this.getGeometry().envelope();
        },
        toString: function () {
            return this.getGeometry().asWkt();
        }
    }
    Class.inherits(PolygonElement, g2.sfs.Element);
    return PolygonElement;
})
